module.exports = function setupMiddlewares(opts, router, sanitizeHtml) {
    if (opts.healthCheck) {
        router.get('/health', (req, res) => {
            const data = { status: 'ok', uptime: process.uptime(), timestamp: Date.now() };
            if (res.json) {
                return res.json(data);
            }
            res.writeHead(200, { 'Content-Type': 'application/json' });
            res.end(JSON.stringify(data));
        });
    }

    if (opts.logger) {
        router.middlewares.unshift((req, res, next) => {
            const start = Date.now();
            res.on('finish', () => {
                const duration = Date.now() - start;
                console.log(`[${req.method}] ${req.url} - ${res.statusCode} (${duration}ms)`);
            });
            next();
        });
    }

    if (opts.cors) {
        router.middlewares.unshift((req, res, next) => {
            const corsOpts = typeof opts.cors === 'object' ? opts.cors : {};
            res.setHeader('Access-Control-Allow-Origin', corsOpts.origin || '*');
            res.setHeader('Access-Control-Allow-Methods', corsOpts.methods || 'GET,POST,PUT,PATCH,DELETE,OPTIONS');
            res.setHeader('Access-Control-Allow-Headers', corsOpts.headers || 'Content-Type, Authorization');

            if (req.method === 'OPTIONS') {
                res.writeHead(204);
                return res.end();
            }
            next();
        });
    }

    if (opts.helmet) {
        router.middlewares.unshift((req, res, next) => {
            res.setHeader('X-Content-Type-Options', 'nosniff');
            res.setHeader('X-Frame-Options', 'SAMEORIGIN');
            res.setHeader('X-XSS-Protection', '1; mode=block');
            res.setHeader('Strict-Transport-Security', 'max-age=31536000; includeSubDomains');
            next();
        });
    }

    if (opts.xss) {
        if (!sanitizeHtml) throw new Error('Please install sanitize-html to use xss middleware');
        router.middlewares.unshift((req, res, next) => {
            const clean = (obj) => {
                for (let key in obj) {
                    if (typeof obj[key] === 'string') {
                        obj[key] = sanitizeHtml(obj[key]);
                    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                        clean(obj[key]);
                    }
                }
            };
            if (req.body) clean(req.body);
            if (req.query) clean(req.query);
            if (req.params) clean(req.params);
            next();
        });
    }

    if (opts.session) {
        const createSessionMiddleware = require('../session');
        const sessionMiddleware = createSessionMiddleware(opts);
        if (sessionMiddleware) {
            router.middlewares.push(sessionMiddleware);
        }
    }

    if (opts.compression) {
        const compression = require('compression');
        router.middlewares.unshift(compression(typeof opts.compression === 'object' ? opts.compression : {}));
    }

    if (opts.htmx) {
        const htmxMiddleware = require('./middlewares/htmx');
        router.middlewares.unshift(htmxMiddleware());
    }
};
